import React from "react";

// O hook saiu deste arquivo em 03/08/2026, quando a cerimônia de card passou a
// digitar a fala do mascote também: um hook não pertence a uma tela, e importar a
// tela inteira só para pegá-lo amarraria a cerimônia à abertura.
import { useTextoDigitado } from "./textoDigitado";

/**
 * Apresentação do mascote, na primeira entrada da trilha.
 *
 * @param {object}   mascote   { nome, corpo, fala }
 * @param {Function} onFechar
 */
function IntroMascote({ mascote, onFechar }) {
  // `completar` fica de fora aqui de propósito: nesta tela o caminho adiante é o
  // botão "Continuar", que já está na tela desde o primeiro quadro — não há o
  // conflito entre "pular a fala" e "prosseguir" que a cerimônia tem.
  const { digitado: textoDigitado, digitando } = useTextoDigitado(mascote.fala);

  return (
    <div
      className="intro-mascote__fundo tl-anim-fade-in"
      role="dialog"
      aria-modal="true"
    >
      <div className="intro-mascote__painel tl-anim-pop-in">
        <img
          className="intro-mascote__figura tl-anim-float"
          src={mascote.corpo}
          alt={mascote.nome}
        />
        {/* Texto "fantasma" (completo, invisível) reserva a altura final desde o
            primeiro quadro — sem ele o botão Continuar ficaria descendo aos
            poucos conforme o texto é digitado. */}
        <div className="intro-mascote__texto-wrap">
          <p
            className="intro-mascote__texto intro-mascote__texto--fantasma"
            aria-hidden="true"
          >
            {mascote.fala}
          </p>
          <p
            className={`intro-mascote__texto intro-mascote__texto--visivel${
              digitando ? " intro-mascote__texto--digitando" : ""
            }`}
          >
            {textoDigitado}
          </p>
        </div>
        <button type="button" className="tl-btn" onClick={onFechar}>
          Continuar
        </button>
      </div>
    </div>
  );
}

export default IntroMascote;
